<template>
    <div class="Footer">
        <div v-if="show" class="Footer-con">
            <div class="box-center flex">
                <div class="Footer-con-left">
                    <p>{{ $t('company.name') }}</p>
                    <div>{{ $t('footer.cont1') }}</div>
                </div>
                <div class="Footer-con-center">
                    <p>{{ $t('footer.title2') }}</p>
                    <div>深圳市华馥科技有限公司</div>
                    <div style="margin-top:6px">Shenzhen huafu technology
                    </div>
                    <div style="margin-top:6px">{{ $t('footer.address') }}</div>
                </div>
                <div class="Footer-con-right">
                    <p>{{ $t('footer.title3') }}</p>
                    <div>
                        <!-- <img :src="require('@/assets/images/time.png')"> -->
                        {{ $t('footer.cont3') }} 09:00-18:00
                    </div>
                    <div>
                        <!-- <img :src="require('@/assets/images/phone.png')"> -->
                        13924583058
                    </div>
                    <div>
                        <!-- <img :src="require('@/assets/images/email.png')"> -->
                        13924583058@139.com
                    </div>
                </div>
            </div>
        </div>
        <div class="Footer-copy">
            <span class="company">© Copyright 2024 深圳市华馥科技有限公司</span>
            <a class="link" href="http://beian.miit.gov.cn" target="_blank"
                style="line-height: 20px;">粤ICP备2024256636号</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
.Footer {
    color: #ffffff;
    background-color: #151823;
    //   border-top: 5px solid #2F3177;

    .Footer-con {
        // background: url(~@/assets/images/footBg.png) no-repeat center;
        height: 212px;


        .Footer-con-left {
            width: 32%;
        }

        .Footer-con-center {
            width: 32%;
        }

        .Footer-con-right {
            width: 24%;

            div {
                margin-bottom: 6px;
            }
        }

        .box-center>div {
            p {
                font-family: 'Noto Sans SC';
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                margin-bottom: 26px;
                margin-top: 37px;
            }

            div {
                font-size: 12px;
                line-height: 26px;

                img {
                    margin-right: 15px;
                    vertical-align: middle;
                }
            }
        }
    }

    .Footer-copy {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 58px;
        line-height: 58px;
        mix-blend-mode: normal;
        // background: #000000;
        text-align: center;
        color: #fff;
        font-size: 14px;

        .company {
            margin-right: 12px;
        }

        .link {
            color: #fff;
        }
    }
}

@media screen and (max-width: 980px) {
    .box-center {
        width: 100%;
    }

    .Footer {
        overflow: hidden;

        .Footer-con {
            padding: 0 5%;
            height: 185px;

            .Footer-con-left {
                display: none;
            }

            .Footer-con-center {
                width: 100%;
            }

            .Footer-con-right {
                width: 100%;

                div {
                    margin-bottom: 6px;
                }
            }
        }

        .Footer-copy {
            flex-flow: column nowrap;
            padding-top: 10px;
            line-height: 20px;
        }
    }
}
</style>
